import React from 'react';
import { UncontrolledPopover, PopoverBody, PopoverHeader } from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    '& .popover': {
      zIndex: '1300'
    }
  }
}));

function ThreeppPopover(props) {
  const { className, toggle, isOpen, header, children, trigger, placement, target } = props;
  const classes = useStyles();
  const popoverClasses = [`${classes.root}`, 'threepp-popover'];
  if (className) {
    popoverClasses.push(className);
  }

  return (
    <UncontrolledPopover
      flip={false}
      toggle={toggle}
      isOpen={isOpen}
      className={popoverClasses.join(' ')}
      trigger={trigger}
      placement={placement}
      target={target}
      boundariesElement="window"
    >
      {header && <PopoverHeader>{header}</PopoverHeader>}
      {children && <PopoverBody>{children}</PopoverBody>}
    </UncontrolledPopover>
  );
}

export default ThreeppPopover;
